export enum RegistrationInteractionTypeEnum {
	PageLanded = "page_landed",
	ExitLogo = "exit_logo",
	ExitLogin = "exit_login",
	ExitOther = "exit_other",
	FieldFilled = "field_filled",
	StepTwoReached = "step_2_reached",
	StepOneReturned = "step_1_returned",
	SubmitClicked = "submit_clicked",
	SubmitSuccess = "submit_success",
	SubmitFailed = "submit_failed",
}
